import { Routes, Route } from '@angular/router';
import { Type } from '@angular/core';
import { SwapPageComponent } from './components/swap-page/swap-page.component';
import { LaunchpadComponent } from './components/launchpad/launchpad.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { HomeComponent } from './components/home/home.component';
import { LiquiditySectionComponent } from './components/liquidity-section/liquidity-section.component';
import { StakePageComponent } from './components/stake-page/stake-page.component';
import { PoolDetailsComponent } from './components/pool-details/pool-details.component';
import { NewPositionComponent } from './components/new-position/new-position.component';
import { YieldFarmingComponent } from './components/yield-farming/yield-farming.component';
import { TokensComponent } from './components/tokens/tokens.component';
import { TokensPageComponent } from './components/tokens-page/tokens-page.component';
import { TokenDetailComponent } from './components/token-detail/token-detail.component';
import { AboutPageComponent } from './components/about-page/about-page.component';
import { ContactPageComponent } from './components/contact-page/contact-page.component';
import { HistoryComponent } from './components/history/history.component';
import { BanklessComponent } from './components/bankless/bankless.component';
import { LegalPageComponent } from './components/legal-page/legal-page.component';
import { AdvantagesComponent } from './components/advantages/advantages.component';
import { cmsPageResolver } from './resolvers/cms-page.resolver';
import { HOME_CMS_IDENTIFIER } from './config/home-cms.defaults';
import { ABOUT_CMS_IDENTIFIER } from './config/about-cms.defaults';
import { CONTACT_CMS_IDENTIFIER } from './config/contact-cms.defaults';
import {
  PRIVACY_CMS_IDENTIFIER,
  TERMS_CMS_IDENTIFIER,
} from './config/legal-cms.defaults';

const cmsRoute = (path: string, component: Type<unknown>, cmsIdentifier: string): Route => ({
  path,
  component,
  data: { cmsIdentifier },
  resolve: { cmsResponse: cmsPageResolver },
  runGuardsAndResolvers: 'always' as const,
});

export const routes: Routes = [
  cmsRoute('', HomeComponent, HOME_CMS_IDENTIFIER),
  { path: 'swap', component: SwapPageComponent },
  { path: 'liquidity', component: LiquiditySectionComponent },
  { path: 'liquidity/new', component: NewPositionComponent },
  { path: 'launchpad', component: LaunchpadComponent },
  { path: 'portfolio', component: PortfolioComponent },
  { path: 'history', component: HistoryComponent },
  { path: 'staking', component: StakePageComponent },
  { path: 'yield-farming', component: YieldFarmingComponent },
  { path: 'tokens', component: TokensPageComponent },
  { path: 'bankless', component: BanklessComponent },
  { path: 'explore', component: TokensComponent },
  { path: 'explore/:symbol', component: TokenDetailComponent },
  { path: 'liquidity/:id', component: PoolDetailsComponent },
  { path: 'advantages', component: AdvantagesComponent },
  cmsRoute('about', AboutPageComponent, ABOUT_CMS_IDENTIFIER),
  cmsRoute('contact', ContactPageComponent, CONTACT_CMS_IDENTIFIER),
  cmsRoute('privacy-policy', LegalPageComponent, PRIVACY_CMS_IDENTIFIER),
  cmsRoute('terms-and-conditions', LegalPageComponent, TERMS_CMS_IDENTIFIER),
  { path: '**', redirectTo: '' },
];
